export const helperAudio = (
  s: any,
  stake: any,
  setaudio: any,
  sendSettings: any
) => {
  setaudio(s);
  sendSettings(stake, s);
};
